export enum LoginOrigemEnum {
    GOV_BR = "govbr",
    MJ = "azuread",
    ESTRANGEIRO = "extern",
}
